import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Stack,
  Link,
} from "@mui/material";

const staffMembers = [
  {
    name: "Kevin Hughes, MD, FACS",
    role: "Director of Cancer Genetics, McKoy Rose Professor of Surgery",
    location: "Medical University of South Carolina",
    image: "/aboutus/hughes.png",
    description: `Dr. Hughes brings decades of experience in hereditary cancer risk management. He is pioneering the use of artificial intelligence to assist in treatment planning and clinical decision-making.`,
    email: "hughkevi@musc.edu",
  },
  {
    name: "Jihad Obeid, MD, FAMIA",
    role: "Endowed Chair and Professor in Biomedical Informatics",
    location: "Medical University of South Carolina",
    image: "/aboutus/obeid.png",
    description: ``,
    email: "jobeid@musc.edu",
  },
  {
    name: "Julie Henderson",
    role: "Assistant Professor of Computer Science, Software Engineer",
    location:
      "Charleston Southern University, Medical University of South Carolina",
    image: "/aboutus/henderson.png",
    description: ``,
    email: "hendejul@musc.edu",
  },
  {
    name: "Andrew Disharoon",
    role: "Software Engineer/Data Scientist",
    location: "Medical University of South Carolina",
    image: "/aboutus/disharoon.png",
    description: ``,
    email: "disharoa@musc.edu",
  },
  {
    name: "Isabelle Museck",
    role: "PhD Student, Graduate Research Assistant",
    location: "Medical University of South Carolina",
    image: "/aboutus/museck.jpg",
    description: `Isabelle is a second year PhD student with a background in Bioengineering from Clemson University. She is passionate about working on projects that apply new technology to improve outcomes for both patients and physicians.`,
    email: "museck@musc.edu",
  },
  {
    name: "Emalie Houk",
    role: "Medical Student",
    location: "Medical University of South Carolina",
    image: "/aboutus/houk.jpg",
    description: `Emalie is a fourth-year medical student and will begin her residency in July of 2026. Her broader research experience includes global health work in Tanzania and investigations into factors affecting women's health outcomes, including pre-eclampsia, sickle cell disease, and disruptions of the gut microbiome.`,
    email: "houke@musc.edu",
  },
  {
    name: "Ahmet Acar, MD",
    role: "Emergency Department Doctor",
    location: "Avrupa Hopital, Istanbul, Turkey",
    image: "/aboutus/acar.jpg",
    description: ``,
    email: "acarahmet8916@gmail.com",
  },
  {
    name: "Meghdeep Sen",
    role: "Medical Student",
    location: "University of Antigua, Coolidge, Antigua",
    image: "/aboutus/sen.jpg",
    description: ``,
    email: "meghdeepsen@gmail.com",
  },
  {
    name: "Kelly Bontempo",
    role: "Senior Genetic Counselor",
    location: "Center for Genomic Medicine, Advocate Aurora Health",
    image: "/aboutus/bontempo.png",
    description: ``,
    email: "kbontem@clemson.edu",
  },
  {
    name: "Jennifer Scalia",
    role: "Teaching Associate in Obstetrics and Gynecology",
    location: "Warren Alpert Medical School of Brown University",
    image: "/aboutus/scalia.png",
    description: ``,
    email: "scalia@g.clemson.edu",
  },
  {
    name: "Conner McCaw",
    role: "Student, Software Engineer Intern",
    location:
      "Charleston Southern University, Medical University of South Carolina",
    image: "/aboutus/mccaw.png",
    description: `Conner is an undergraduate Computer Science student at Charleston Southern University and an intern at MUSC. He designed and built the landing pages for hereditarycancer.ai, focusing on front-end development, user experience, and making cancer research more accessible online.`,
    email: "cjmprofessional@gmail.com",
  },
];

export default function AboutUsPage() {
  return (
    <Box
      sx={{
        px: { xs: 3, md: 8 },
        py: { xs: 6, md: 10 },
        backgroundColor: "#f9f9f9",
      }}
    >
      {/* Header */}
      <Stack spacing={2} alignItems="center" sx={{ mb: 6 }}>
        <Typography variant="h3" fontWeight="bold" color="#1B2E85">
          About Us
        </Typography>
        <Typography variant="body1" textAlign="center" sx={{ maxWidth: 700 }}>
          Meet the team leading the charge in hereditary cancer innovation,
          combining technology, medicine, and compassion.
        </Typography>
      </Stack>

      {/* Horizontal Cards */}
      <Stack spacing={6}>
        {staffMembers.map((member, index) => (
          <Card
            key={index}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "stretch",
              boxShadow: 3,
            }}
          >
            <CardMedia
              component="img"
              image={member.image}
              alt={member.name}
              sx={{
                width: 280,
                height: 280,
                objectFit: "cover",
                flexShrink: 0,
              }}
            />
            <CardContent
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                p: { xs: 3, md: 4 },
              }}
            >
              <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
                {member.name}
              </Typography>

              <Typography
                variant="subtitle1"
                color="text.secondary"
                sx={{ mb: 0.5, maxWidth: 600 }}
              >
                {member.role}
              </Typography>

              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ mb: 2, maxWidth: 600 }}
              >
                {member.location}
              </Typography>

              <Typography variant="body1" color="text.primary" sx={{ mb: 2 }}>
                {member.description}
              </Typography>

              <Box sx={{ mt: "auto" }}>
                <Typography variant="body2" color="text.secondary">
                  Email:{" "}
                  <Link href={`mailto:${member.email}`} underline="hover">
                    {member.email}
                  </Link>
                </Typography>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}
